module.exports = __webpack_public_path__ + "img/login_img_shenhezhong@3x.ee5c7b68.png";